
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxSeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaxonomySEO"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canonical"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cornerstone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"focuskw"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"metaDesc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"metaRobotsNofollow"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"metaRobotsNoindex"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"opengraphAuthor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"opengraphDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"opengraphModifiedTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"opengraphPublishedTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"opengraphPublisher"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"opengraphSiteName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"opengraphTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"opengraphType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"opengraphUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"twitterDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"twitterTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"breadcrumbs"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"schema"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raw"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"opengraphImage"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SimpleImage"},"directives":[]}]}}]}}],"loc":{"start":0,"end":492}};
    doc.loc.source = {"body":"#import \"./SimpleImage.gql\"\n\nfragment TaxSeo on TaxonomySEO {\n  canonical\n  cornerstone\n  focuskw\n  metaDesc\n  metaKeywords\n  metaRobotsNofollow\n  metaRobotsNoindex\n  opengraphAuthor\n  opengraphDescription\n  opengraphModifiedTime\n  opengraphPublishedTime\n  opengraphPublisher\n  opengraphSiteName\n  opengraphTitle\n  opengraphType\n  opengraphUrl\n  title\n  twitterDescription\n  twitterTitle\n  breadcrumbs {\n    text\n    url\n  }\n  schema {\n    raw\n  }\n  opengraphImage {\n    ...SimpleImage\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./SimpleImage.gql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["TaxSeo"] = oneQuery(doc, "TaxSeo");
        
